import type { DeliveryRecord } from '@youkuai/contracts';

export type DeliveryDisplayState = 'DELIVERED' | 'PENDING_DELIVERY' | 'NOT_READY';

export function deliveryDisplayState(contentStatus: string,
  records: ReadonlyArray<Pick<DeliveryRecord, 'current' | 'status'>>): DeliveryDisplayState {
  if (records.some((record) => record.current)) return 'DELIVERED';
  if (contentStatus === 'PENDING_DELIVERY' || records.some((record) => record.status === 'WITHDRAWN'))
    return 'PENDING_DELIVERY';
  return 'NOT_READY';
}
